export const APP_VERSION = '3.1.0'
export const RUSSIA_COUNTRY_CODE = 643
export const BELARUS_COUNTRY_CODE = 112

export const ENABLE_REDUX_DEV_TOOLS = true

export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
}

export const THEMES_RUSSIAN = {
  LIGHT: 'Светлая',
  ONE_DARK: 'Темная',
}

export const ORDER_STATUSES_IN_RUS = {
  Новые: 10,
  На_согласовании: 20,
  Отменены: 30,
  Выкуплены: 40,
  На_закупке: 50,
  Перенесен_в_товары: 60,
}

export const SHIPMENT_STATUSES_IDS = {
  WAITING_ON_STORE: 1,
  RECEIVED_FROM_COURIER: 2,
  PROCESSED_WAREHOUSE: 3,
  ADDED_TO_BAG: 4,
  ADDED_TO_REGISTRY: 5,
  LEFT_CHINA_WAREHOUSE: 6,
  ARRIVED_AT_CHINA_CUSTOMS: 7,
  NOT_REGISTERED: 10,
}

export const ORDER_STATUSES = {
  'new-orders': 10,
  'pending_price_confirmation': 20,
  'canceled': 30,
  'redeemed': 40,
  'waiting_to_be_purchased': 50,
  'moved_to_goods': 60,
  'waiting_for_payment_on_dobroPoizon': 70,
}

export const roles = {
  ROLE_ADMIN: 'Администратор',
  ROLE_ACCEPTOR_CARGO: 'ACCEPTOR_CARGO',
  ROLE_ADMINISTRATOR: 'Администратор',
  ROLE_WAREHOUSE_DIRECTOR: 'Директор склада',
  ROLE_SUPPORT_DIRECTOR: 'Директор службы поддержки',
  ROLE_DIRECTOR: 'Директор',
  ROLE_OPERATOR: 'Оператор',
  ROLE_PACKER: 'Упаковщик',
  ROLE_STOREKEEPER: 'Кладовщик',
  ROLE_SYSTEM: 'SYSTEM',
  ROLE_REDEEMER: 'REDEEMER',
  ROLE_CARGO_USER: 'CARGO_USER',
  ACCEPTOR_CARGO_ADMIN: 'ACCEPTOR_CARGO_ADMIN',
  ROLE_BUYERS_DIRECTOR: 'BUYERS_DIRECTOR',
  ROLE_PVZ: 'PVZ',
}

export const I18_COOKIE_NAME = 'i18next'

export const RUSSIA_LANGUAGE_CODE = 'ru'
export const CHINA_LANGUAGE_CODE = 'zh'

export const ADDITIONAL_SERVICE_TYPES = {
  DETAILED_CHECK: 1, // **Детальная проверка**
  PARCEL_PACKAGING: 2, // **Упаковка посылки**
  REGISTRATION_OF_DOCUMENTS: 3, // **Оформление документов**
  CONSOLIDATION_WITHOUT_VERIFICATION: 4, // **Консолидация без проверки**
  REGISTRATION_OF_DOCUMENTS_READY_GOOD: 6, // **Оформление документов Готовый груз**
  PARCEL_RE_PACKAGING: 11, // **Переупаковка посылок с поврежденной тарой**
  PHOTO_REPORT: 12, // **Детальные фотографии товара**
  LEAVE_ORIGINAL_PACKAGING: 14, // **Убрать оригинальную упаковку**
  // 15 is «Обрешётка посылки» — see LATTICE_SERVICE_ID below
  REMOVE_POSTAL_PACKAGING: 16, // **Убрать почтовую упаковку / мусор**
}

export const APPLY_TO = {
  CARGO: 'Груз',
  PACKAGE: 'Посылка',
}

export const PACKAGE_TYPE = {
  FINISHED_CARGO: 'Готовый груз',
  CONSOLIDATION: 'Консолидация',
}

export const EVENT = {
  WEIGHING_THE_PARCEL: 'Взвешивание посылки',
  ACCEPTANCE_OF_CARGO: 'Прием груза на склад',
}

export const AMOUNT_UNIT = {
  FIXED: 'Фиксированное значение',
  KG: 'Килограмм',
  ITEM: 'Лот',
  FIXED_BY_WEIGHT: 'Фиксированное (По весу)',
}

export const PACKAGE_STATUSES = {
  GOODS_REQUEST: 5,
  READY_GOODS: 9,
  WAITING: 10,
  DOES_NOT_MEET_REQUIREMENTS: 11,
  RECEIVED: 12,
  WAIF: 13,
  DISPOSED_OF: 14,
  AWAITING_DISPOSAL: 15,
  FORBIDDEN: 16,
  ONSTORE: 20,
  SENT: 30,
  READY_GOODS_PROCESSED: 40,
  NO_GOODS: 90,
  CANCELED: 100,
  RETURN_TO_SENDER: 110,
  RETURNED_TO_SENDER: 120,
  IN_PARCEL: 130,
  ON_PICKING: 140,
  UNCERTAIN_PRODUCT: 150,
  DELIVERED: 160,
  AWAITING_RETURN: 111,
  RETURN_IS_OVERDUE: 112,
  CANCELLATION_OF_RETURN: 113,
  HANDED_OVER_TO_THE_COURIER: 115,
  CHANGE_DATA: 114,
}

export const CARGO_STATUSES = {
  EQUIPMENT: 1,
  WEIGHING: 2,
  AWAITING_SHIPMENT: 3,
  SENT: 4,
  RECEIVED_WAREHOUSE: 5,
  SENT_TK: 6,
}

export const PARCEL_STATUSES = {
  ON_ASSEMBLY: 20,
  ON_WEIGHING: 30,
  AWAITING_PAYMENT: 33,
  CHANGING_PARCEL_DETAILS: 35,
  READY_FOR_SENT: 40,
  READY_FOR_PVZ_PICKUP: 43,
  ISSUED_TO_RECIPIENT: 44,
  WAITING_FOR_ARCHIVE: 99,
  ARCHIVE: 102,
  DISPOSED_OF: 104,
}

export const TOOL_KIND_GOOD_HAZARD_CATEGORY = {
  PROHIBITED: 1,
  DANGEROUS: 2,
  SUPER_DANGEROUS: 3,
  // LIQUID: 2,
  // SAFE_PRODUCT: 1,
}

export const DELIVERY_TRANSPORT = {
  DP_EXPRESS_MSK: 113,
  DP_BELARUS: 115,
  DP_VLADIVASTOK: 63,
  DP_ECONOMY: 6,
}

export const PARCEL_PACKAGE_TOOL_KIND = {
  PACKAGE_BY_BOX: 1,
  PACKAGE_BY_BAG: 2,
  PACKAGE_BY_CASE: 15,
}

export const LAST_MILE_OPERATORS = {
  NEW_POST: 1,
  SBERLOGISTICA: 2,
  CDEK: 3,
  PVZ_DOBROPOST: 4,
  BOXBERRY: 5,
  POSTAL_RU: 6,
  DPD: 8,
  EUROPOST: 9,
}

export const ORDER_PAGE_TYPES = {
  new_orders: 'NEW',
  waiting_to_be_purchased: 'WAITING_TO_BE_PURCHASED',
  redeemed: 'PURCHASED',
  pending_price_confirmation: 'PENDING_PRICE_CONFIRMATION',
  moved_to_goods: 'TRANSFERRED_TO_GOODS',
  canceled: 'CANCELED',
}

export const ORDER_URLS = {
  NEW_ORDERS: 'new-orders',
  PENDING_PRICE_CONFIRMATION: 'pending_price_confirmation',
  CANCELED: 'canceled',
  REDEEMED: 'redeemed',
  WAITING_TO_BE_PURCHASED: 'waiting_to_be_purchased',
  MOVED_TO_GOODS: 'moved_to_goods',
  WAITING_FOR_PAYMENT_ON_DOBROPOIZON: 'waiting_for_payment_on_dobroPoizon',
  CHECKING_REGISTRY_DATA_CHECK: 'checking_registry_data_checking',
  CHECKING_REGISTRY_DATA_SHIPMENT: 'checking_registry_data_shipment',
  CHECKING_REGISTRY_DATA_TABLE: 'checking_registry_data_table',
  CHECKING_REGISTRY_DATA_TABLE_SHIPMENT:
    'checking_registry_data_table_shipment',
  CHECKING_REGISTRY_DATA: 'checking_registry_data',
  GOODS_MORE_THEN_FIVE_DAY: 'goods_more_then_five_day',
}

export const CARGO_URLS = {
  CARGO_RETURNS_BY_CODE: 'by_code',
  CARGO_RETURNS_BY_ADDRESS: 'by_address',
}

export const PVZ_URLS = {
  ACCEPT: 'accept',
  ISSUE: 'issue',
}

// Scan event types for POST /api/pvz/data/scan (EPVZScanType).
export const PVZ_SCAN_TYPE = {
  RECEPTION: 'RECEPTION',
  DELIVERY: 'DELIVERY',
}

// Additional service id for "Обрешетка" (lattice/crating). Used to detect whether
// a parcel has the lattice service applied via parcel.additionalServices.
export const LATTICE_SERVICE_ID = 15

export const WAIF_PICTURE = 'waifPicture'
export const PHOTO_DEFECT_URL = 'photoDefectUrl'
export const PHOTO_REPORT_URL = 'photoReportUrl'
export const PICTURE_FEE_WAIF = 'pictureFeeWaif'
export const MAX_CHINESE_TRACK_NUMBER_LENGTH = 15
export const DEBOUNCE_DELAY_MS = 800
export const PARCEL_WEIGHT_LIMIT_WEIGHTING = 35

export const COMMISSION_ORDER_CONFIRMATION = 5 // 5% IN JSX
export const COMMISSION_INTERNATIONAL = 15 // 15% for international lots

export const SORTING_SEQUENCE = {
  ASC: 'asc',
  DESC: 'desc',
}

export const REQUEST_VALUE = {
  SUCCESS: 'success',
  ERROR: 'error',
}

export const ACCEPTABLE_STATUS = [
  'RECEIVED',
  'WAITING',
  // 'DOES_NOT_MEET_REQUIREMENTS',
]

export const PARCEL_CN_STATUSES = {
  'Ожидает отправку': '等寄出包裹',
  'Готова к комплектации': '准备配成全套了',
  'На комплектации': '正在进行配成全套',
  'На взвешивании': '称重',
  'Добавлена в реестр № %s': '已经添加到 RU 注册表',
  'На таможне в Китае': '在海关在华',
  'Покинула склад DP в Китае': '包裹离开仓库在华了',
  'Ожидает отгрузки со склада': '等仓库发运',
  'Ожидает оплату': '未付款包裹',
  'Готовый Груз': '货物准备运输了',
  'Изменение данных посылки': '信息修改',
  'Архив': '信息库',
  'Ожидает утилизации': '等待销毁',
  'Утилизирован': '销毁了',
}

export const affectedGoodStatuses = [
  { status: 'ONSTORE', labelRu: 'На складе', id: 20 },
  {
    status: 'DOES_NOT_MEET_REQUIREMENTS',
    labelRu: 'Не соответствует требованиям',
    id: 11,
  },
  { status: 'SENT', labelRu: 'Отправлен в посылке № %s', id: 30 },
  //
]

export const ORDERS_TYPE = {
  DOBRPOIZON: 'DOBRPOIZON',
  MANUAL: 'MANUAL',
  FROM_SHOP: 'FROM_SHOP',
}

// Commission level labels keyed by commission percentage
export const COMMISSION_LEVEL_BY_PCT = {
  10: 'Базовый',
  8: 'Серебро',
  6: 'Золото',
  5: 'Бриллиант',
}

export const BAG_PARCEL_STATUS = {
  NEW: 1,
  CLOSED: 2,
}

export const USER_ROLES = {
  ROLE_ADMIN: 'ADMINISTRATOR',
  BUYERS_DIRECTOR: 'BUYERS_DIRECTOR',
  WAREHOUSE_DIRECTOR: 'WAREHOUSE_DIRECTOR',
}

export const GOODS_TYPES = {
  shipment: 'SHIPMENT',
  good: 'GOOD',
}

export const BAG_TYPE = {
  SHIPMENT: 'SHIPMENT',
  PARCEL: 'PARCEL',
}

export const IMAGE_DOMAIN = 'https://images.dobropost.com/'

export const BAG_TYPE_COMPRESSION_STR = 'Shipment'
export const BASE_URL_VERSION = 'v2'

export const MAX_FILE_SIZE_MB_EXCEL_UNITRADE = 5
export const ACCEPTED_TYPES_FOR_EXCEL_UNITRADE = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-excel', // .xls
]

export const routersWithoutLayout = [
  '/login',
  '/login-unprotected',
  '/register',
  '/verify-otp',
  '/reset-password',
  '/register-unprotected',
  '/404',
  '/shipmenttag',
  '/pdf/create',
]

export const routersWithoutTopBar = [
  '/app/cargo/courier-accept/mobile-redesign',
]

// Шипмент тяжелее этого веса принять нельзя — кнопка «Принять» блокируется.
export const SHIPMENTS_WEIGHT_MAX = 50

export const SHIPMENT_ADDITIONAL_SERVICES = {
  CHECK: 1,
  PHOTO_REPORT: 2,
  REMOVE_POSTAL_PACKAGING: 3,
}

export const AUTH_STATUS = {
  TWO_FA_REQUIRED: '2FA_REQUIRED',
  SUCCESS: 'SUCCESS',
}
